/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as transectionService from '../../../services/transectionService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
import * as utils from '../../../util/string.util';
class CreditModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         amount: null,
         remark: "",
         mpassword: "",
         toastMsg: "",
         toastType: "",
         clientBalance: "",
         afterClientBalance: 0,
         currUserData: {},
         currUserBalance: 0,
         afterCurrUserBalance: 0,
         loading: false,
         credit_ref: ""
      };
   }
   componentDidMount() {
      let currUserData;
      let currentLoggedInUser = JSON.parse(localStorage.getItem('userAccData'));
      
      if (!!this.props.user_id) {
         currUserData = localStorage.getItem(this.props.user_id)
         currUserData = JSON.parse(currUserData)
         this.setState({ currUserData: currUserData, currUserBalance: utils.toFixedDigit(parseFloat(currUserData.availableBalance) ) , clientBalance: parseFloat(this.props.user.availableBalance), remark: `Deposit chips to ${this.props.user.username} from ${currentLoggedInUser.username}` })
      } else {
         currUserData = localStorage.getItem("userAccData")
         currUserData = JSON.parse(currUserData)
         this.setState({ currUserData: currUserData, currUserBalance: utils.toFixedDigit(parseFloat(currUserData.availableBalance)  ), clientBalance: parseFloat(this.props.user.availableBalance), remark: `Deposit chips to ${this.props.user.username} from ${currentLoggedInUser.username}` })
      }
      // debugger
   }
   handleKey(e) {
      if (e.keyCode === 13) {
         this.onSubmit();
      }
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 5000);
      })
   }
   async onSubmit(){
      if((parseFloat(this.state.amount) === 0 || this.state.amount === "" || this.state.amount === null) && ( this.state.credit_ref === "")){
         return false
      }
      else if((!!this.state.amount && !!this.state.currUserBalance) && parseFloat(this.state.amount) > this.state.currUserBalance){
         this.props.notify("Invalid Amount!", "error");
      }
      else if( ( !(parseFloat(this.state.amount) === 0 || this.state.amount === "" || this.state.amount === null)) && this.state.credit_ref !== "" ){
         if (this.state.loading) {
            return false
         } else {
            this.setState({ loading: true }, async () => {               
               let cred = await this.onCreditReference();
               if(cred){
                  let depo = await this.onDeposite();
                  if(depo){
                     this.props.notify("Credit Updated and Deposit amount successfully!", "success");
                     setTimeout(() => {this.props.closeAndUpdate()}, 500)
                  }else{
                     setTimeout(() => { this.setState({ loading: false }) }, 500)
                  }
               }else{
                  setTimeout(() => { this.setState({ loading: false }) }, 500)
               }
            })
         }
      }
      else if( this.state.credit_ref !== "" ){
         if (this.state.loading) {
            return false
         } else {
            this.setState({ loading: true }, async () => {
               let cred = await this.onCreditReference();
               if(cred){
                  this.props.notify("Credit Updated successfully!", "success");
                  setTimeout(() => {this.props.closeAndUpdate()}, 500)
               }else{
                  setTimeout(() => { this.setState({ loading: false }) }, 500)
               }
            })
         }
      }
      else if( !(parseFloat(this.state.amount) === 0 || this.state.amount === "" || this.state.amount === null)){
         if (this.state.loading) {
            return false
         } else {
            this.setState({ loading: true }, async () => {
               let depo = await this.onDeposite();
               if(depo){
                  this.props.notify(" Deposit amount successfully!", "success");
                  setTimeout(() => {this.props.closeAndUpdate()}, 500)
               }else{
                  setTimeout(() => { this.setState({ loading: false }) }, 500)
               }
            })
         }
      }
   }
   async onCreditReference() {
      let data = {
         "creditRefAmount": !!this.state.credit_ref ? parseFloat(this.state.credit_ref) : this.props.user.creditRef,
         "username": this.props.user.username,
         "masterPassword": this.state.mpassword,
         "description": "Update Credit Reference"
      }
      let res = await transectionService.creditRef(data);
      if (res.isSuccess) {
         return true
      } else {
         this.props.notify(res.exception.message, "error");
         return false
      }
   }
   async onDeposite() {
      let data = {
         "creditAmount": parseFloat(this.state.amount),
         "username": this.props.user.username,
         "masterPassword": this.state.mpassword,
         "description": this.state.remark
      }
      let res = await transectionService.creditIn(data)
      if (res.isSuccess) {
         return true
      } else {
         this.props.notify(res.exception.message, "error");
         return false
      }
      
   }
   change(e) {
      const name = e.target.name;
      let value = e.target.value;
      this.setState({ [name]: value })
   }
   onAmountChange(e) {
      const name = e.target.name;
      let value = e.target.value;
      if (value) {
         let afterCurrUserBalance = this.state.currUserBalance
         afterCurrUserBalance = afterCurrUserBalance - parseFloat(value)
         let afterClientBalance = this.state.clientBalance
         afterClientBalance = afterClientBalance + parseFloat(value)
         this.setState({ [name]: value, afterCurrUserBalance: afterCurrUserBalance, afterClientBalance: afterClientBalance })
      }
      else {
         this.setState({ [name]: value, afterCurrUserBalance: 0, afterClientBalance: 0 })
      }
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">Credit / Deposit</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop pt-0">
                        <div className="row tab-hide">
                           <div className="col-md-8">
                           </div>
                           <div className="col-md-4">
                              <label className="deposite-user-first mb-0 pl-1">After</label>
                           </div>
                        </div>
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label className="deposite-user-first">My Available</label>
                           </div>
                           <div className="col-md-4">
                              <span className="popup-box wid-98" id="deposite-first">{!!this.state.currUserBalance ? this.state.currUserBalance : "0.00"}</span>
                           </div>
                           <div className="col-md-4">
                              <label className="deposite-user-first mb-0 pl-1 dd-hide">After</label>
                              <span className="popup-box wid-98" id="deposite-first">{!!this.state.afterCurrUserBalance ? this.state.afterCurrUserBalance : 0}</span>
                           </div>
                        </div>

                        <div className="mycredpart">
                           <div className="row m-b-20">
                              <div className="col-md-6">
                                 <label>Old Cred Ref.</label>
                                 <input type="number" autoFocus tabIndex="" className="maxlength10 popup-box form-control w-100" value={!!this.props.user.creditRef ? this.props.user.creditRef : 0.00} disabled />
                              </div>
                              <div className="col-md-6">
                                 <label>New Cred Ref.</label>
                                 <input type="number" name="credit_ref" autoFocus tabIndex={1} onChange={(e) => { this.change(e) }} className="maxlength10 form-control w-100" value={this.state.credit_ref} />
                              </div>
                           </div>
                        </div>
                        <div className="mycredpart mt-3">
                           <div className="row m-b-20 mt-2">
                              <div className="col-md-4">
                                 <label className="deposite-user-first">{this.props.user.username}</label>
                              </div>
                              <div className="col-md-4">
                                 <span className="popup-box wid-98" id="deposite-first">{!!this.state.clientBalance ? this.state.clientBalance : "0"}</span>
                              </div>
                              <div className="col-md-4">
                                 <label className="deposite-user-first mb-0 pl-1 dd-hide">After</label>
                                 <span className="popup-box wid-98" id="deposite-first">{!!this.state.afterClientBalance ? this.state.afterClientBalance : ""}</span>
                              </div>
                           </div>
                           <div className="row m-b-20">
                              <div className="col-md-4">
                                 <label>Add Deposit</label>
                              </div>
                              <div className="col-md-8">
                                 <input type="number" name="amount" autoFocus tabIndex={2} onChange={(e) => { this.onAmountChange(e) }} className="maxlength10 form-control w-100" value={this.state.amount} />
                              </div>
                           </div>
                           <div className="row m-b-20">
                              <div className="col-md-4">
                                 <label>Remarks</label>
                              </div>
                              <div className="col-md-8">
                                 <textarea name="remark" id="deposit-remark" className="form-control w-100" tabIndex={3} onChange={(e) => { this.change(e) }} value={this.state.remark}></textarea>
                              </div>
                           </div>
                        </div>
                        <div className="row m-b-20 mt-3">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" name="mpassword" className="form-control w-100" tabIndex={4} id="mpassword" onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.change(e) }} required="" />
                           </div>
                        </div>
                        {!!this.state.amount && this.state.amount > this.state.currUserBalance &&
                           <div className="row m-b-20">
                              <div className="col-md-12 text-center">
                                 <span className="text-red">Insufficient Balance</span>
                              </div>
                           </div>
                        }
                     </div>
                     <div className="modal-footer">
                        <button onDoubleClickCapture={(e) => { e.preventDefault(); return false; }} disabled={((parseFloat(this.state.amount) === 0 || this.state.amount === "" || this.state.amount === null) && this.state.credit_ref === "") ? true : false} onClick={() => { if (!this.state.loading) { this.onSubmit() } }} tabIndex={4} className="pop-edit-btn" style={{ cursor: "pointer" }}>Submit {this.state.loading && <img alt="" style={{ height: "16px" }} src={BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</button>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel </a>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(CreditModel);